import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { IInventoryIssueModal } from 'pages/Inventory/Issues/InventoryIssueModal'
import { toast } from 'react-toastify'
import { IPaginatedResponse } from 'types/api/general.interface'
import {
  IGetAllInventoryIssuesSingleResponse,
  IInventoryIssuePostRequest,
} from 'types/api/inventoryReceiptsApi.interface'
import { IInventoryIssuesSlice } from 'types/inventory.interface'
import { baseUrl } from 'utils/axios'
import { formatParams, getParams, handleErrors } from 'utils/helpers'

const initialState: IInventoryIssuesSlice = {
  isLoading: false,
  issues: [],
  totalCount: 0,
  totalPages: 0,
}

export const getInventoryIssues = createAsyncThunk(
  'inventoryIssues/getInventoryIssues',
  async (params: any, thunkAPI) => {
    try {
      params = formatParams(params)
      const resp: AxiosResponse<IPaginatedResponse<IGetAllInventoryIssuesSingleResponse>> =
        await baseUrl.get('inventory/issue', { params })
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const addInventoryIssue = createAsyncThunk(
  'inventoryIssues/addInventoryIssue',
  async (data: IInventoryIssueModal, thunkAPI) => {
    const request: IInventoryIssuePostRequest = {
      transactionDate: data.transactionDate.toISOString(),
      fromLocationId: data.fromLocation.value,
      assignedForUserId: data.assignedUser.value,
      lines: data.lines.map((l) => ({
        itemId: l.item.value,
        quantity: l.quantity,
        lineNotes: l.lineNotes,
      })),
    }
    try {
      const resp: AxiosResponse = await baseUrl.post('inventory/issue/', request)
      await thunkAPI.dispatch(getInventoryIssues(getParams({ location, limit: 30 })))
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const inventoryIssuesSlice = createSlice({
  name: 'inventoryIssues',
  initialState,
  reducers: {
    clearInventoryIssues(state) {
      state.totalCount = 0
      state.totalPages = 0
      state.issues = []
    },
  },
  extraReducers: {
    [getInventoryIssues.pending.type]: (state) => {
      state.isLoading = true
    },
    [getInventoryIssues.fulfilled.type]: (state, { payload }) => {
      state.isLoading = false
      state.issues = payload.data
      state.totalPages = payload.totalPages
      state.totalCount = payload.totalCount
    },

    [getInventoryIssues.pending.type]: (state) => {
      state.isLoading = true
    },
    [addInventoryIssue.pending.type]: (state) => {
      state.isLoading = true
    },
    [addInventoryIssue.fulfilled.type]: (state) => {
      state.isLoading = false
      toast.success('Issue successfully added')
    },
    [addInventoryIssue.rejected.type]: (state, { payload }) => {
      state.isLoading = false
      handleErrors(payload)
    },
  },
})

export const { clearInventoryIssues } = inventoryIssuesSlice.actions

export default inventoryIssuesSlice.reducer
